export const stripObjectValues = (obj: Record<string, any>, names: string[]): [Record<string, any>, any[]] => {
  const returnData = Object.assign({}, obj)
  const nameValues = names.map(name => {
    const value = returnData[name]
    delete(returnData[name])
    return value
  })
  return [returnData, nameValues]
}

export const removeEmptyFields = (obj: Record<string, any>): Record<string, any> => {
  return Object
    .keys(obj)
    .reduce<Record<string, any>>((all, field) => {
      const value = obj[field]
      if(typeof(value) === 'string') {
        if(value) all[field] = value
      }
      else all[field] = value
      return all
    }, {})
}